// extracted by mini-css-extract-plugin
export var section = "isc-module--section--1nxfI";